import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import Contact from "./components/Contact";
import AnnouncementPage from "./components/Announcement";
import AnnouncementForm from "./components/AnnouncementForm";
import Eac from "./components/Eac";
import IntroductionPage from "./components/IntroductionPage";
import Footer from "./components/Footer";
import NewsForm from "./components/NewsEntryForm";
import Itdept from "./components/itdepartment";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/footer" element={<Footer />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/announcements" element={<AnnouncementPage />} />
        <Route path="/announcement-form" element={<AnnouncementForm />} />
        <Route path="/eac" element={<IntroductionPage />} />
        <Route path="/news" element={<NewsForm />} />
        <Route path="/presentation" element={<IntroductionPage />} />
        <Route path="/it-department" element={<Itdept />} />
      </Routes>
    </Router>
  );
}

export default App;
